import { combineReducers } from 'redux';
import { coreUsersCurrentGetAsyncSlice } from './get';
import { coreUsersCurrentPatchSlice } from './patch';
import { updateCurrentUserSyncSlice } from './update';

import { combineAllWatchers, joinReducers } from '@sonar-software/xuder';
import { coreUsersCurrentPictureReducers, coreUsersCurrentPictureWatchers } from './picture';

export const coreUsersCurrentReducers = combineReducers({
	get: joinReducers(
		[ coreUsersCurrentGetAsyncSlice.asyncReducers, updateCurrentUserSyncSlice.syncReducer ],
		coreUsersCurrentGetAsyncSlice.asyncState
	),
	patch: coreUsersCurrentPatchSlice.asyncReducers,
	picture: coreUsersCurrentPictureReducers
});

export const coreUsersCurrentWatchers = combineAllWatchers([
	coreUsersCurrentGetAsyncSlice.asyncWatchers,
	coreUsersCurrentPatchSlice.asyncWatchers,
	coreUsersCurrentPictureWatchers
]);
